// bao migrate skip
import BaseViewModel2 from "./base-view-model2";
import TabPage from "./tab-page";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
/**
 * Makes BaseViewModel2 working without a Tab-Page!
 * Use this class, if you want to open a default BaseController form in a dialog instead a tabpage.
 */
class BaseViewModelForDialog extends BaseViewModel2 {
    CompleteCheck(): boolean | JQueryPromise<boolean> {
        return true;
    }
    Parent: any;
    ControllerName: KnockoutObservable<string>;
    constructor(parent: any) {
        // create dummy tab page
        let tmpTabPage = new TabPage();
        super(tmpTabPage);
        this.Parent = parent;
        this.PrimaryKeyValue = ko.observable(null);
        this.ControllerName = ko.observable(null);
    }
    /**
     * make sure, this function will be called initial!
     */
    init() {
        this.TabPage.IsLoading(true);
        return Bao.post(this.InitUrl(), JSON.stringify({ id: this.PrimaryKeyValue() }), (model) => {
            ko.map.fromJS(model.Definition, this);
            ko.map.fromJS(model.Model, this, this.TabPage.DirtyFlag);
        });
    }
    InitUrl() {
        let controllerName: any = this.ControllerName();
        if (controllerName == false) {
            console.error("InitUrl must be set!!!");
            throw "InitUrl must be set!!!";
        }
        return this.ControllerName() + "/init";
    }
}
export default BaseViewModelForDialog;